module.exports = __webpack_public_path__ + "img/toast-success.af78a1ed.png";